import { app } from "@/services/feathers";
import { map, filter, groupBy } from 'lodash';

export default {
    namespaced: true,
    state: {
        concursos: JSON.parse(sessionStorage.getItem('concursos')) || [],
        meusConcursos: JSON.parse(sessionStorage.getItem('meusConcursos')) || [],
        concursosEncerrados: JSON.parse(sessionStorage.getItem('concursosEncerrados')) || [],
        lastFetch: sessionStorage.getItem('lastFetch') || null
    },
    mutations: {
        SET_CONCURSOS(state, concursos) {
            state.concursos = concursos;
            sessionStorage.setItem('concursos', JSON.stringify(concursos));
        },
        SET_MEUS_CONCURSOS(state, meusConcursos) {
            state.meusConcursos = meusConcursos;
            sessionStorage.setItem("meusConcursos", JSON.stringify(meusConcursos));
        },
        SET_CONCURSOS_ENCERRADOS(state, concursosEncerrados) {
            state.concursosEncerrados = concursosEncerrados;
            sessionStorage.setItem("concursosEncerrados", JSON.stringify(concursosEncerrados));
        },
        SET_LAST_FETCH(state, timestamp) {
            state.lastFetch = timestamp;
            sessionStorage.setItem('lastFetch', timestamp);
        }
    },
    actions: {
        async fetchConcursos({ commit, rootState }) {
            const currentTime = new Date().getTime();

            try {
                const auth = rootState.auth;

                // Chamando a API se os dados não estiverem no sessionStorage
                const response = await app.service("selective-processes").find({
                    query: {
                        $sort: {
                            createdAt: -1,
                        },
                    },
                });
                const ps_open = filter(response, ps => !ps.closed);
                const ps_closed = filter(response, ps => ps.closed);
                const links = map(ps_open, ps => ({
                    title: ps.title,
                    to: `/processos/${ps._id}`,
                    type: 'PUBLIC'
                }));
                const linksClosed = map(groupBy(ps_closed, ps => new Date(ps.createdAt).getFullYear()), (pss, ano) => ({
                    ano,
                    pss: map(pss, ps => ({
                        title: ps.title,
                        to: `/processos/${ps._id}`,
                        type: 'PUBLIC'
                    }))
                }));
                commit('SET_CONCURSOS', links);
                commit('SET_CONCURSOS_ENCERRADOS', linksClosed);
                commit('SET_LAST_FETCH', currentTime);

                // VERIFICANDO SE O USUÁRIO ESTÁ LOGADO PARA A PARTE PRIVADA
                if (!auth.token) return;

                const my_inscriptions = await app.service("inscriptions").find({
                    query: {
                        id_user: auth.user._id,
                        $sort: {
                            createdAt: -1,
                        },
                    },
                });
                const my_ps = await Promise.all(map(my_inscriptions, async e => {
                    const ps = await app.service("selective-processes").get(e.id_ps);
                    return {
                        title: ps.title,
                        to: `/processos/${ps._id}`,
                        type: 'PUBLIC'
                    };
                }));
                commit('SET_MEUS_CONCURSOS', my_ps);

            } catch (error) {
                console.error('Erro na API', error);
            }
        }
    },
    getters: {
        concursos: state => { return state.concursos || [] },
        meusConcursos: state => { return state.meusConcursos || [] },
        concursosEncerrados: state => { return state.concursosEncerrados || [] }
    },
    modules: {},
};